/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificaPushInvioDTO { 
    id?: string;
    /**
     * UTENTE_SINGOLO, GLOBALE oppure SELEZIONE.
     */
    destinatario_tipo?: NotificaPushInvioDTODestinatarioTipoEnum;
    /**
     * Id dell\'utente destinatario; presente solo per UTENTE_SINGOLO.
     */
    destinatario_user_id?: string;
    /**
     * Id del Comune usato come filtro o come perimetro; assente se l\'invio era senza comune.
     */
    comune_id?: string;
    titolo?: string;
    messaggio?: string;
    stato?: NotificaPushInvioDTOStatoEnum;
    /**
     * Dispositivi selezionati come destinatari all\'avvio.
     */
    destinatari_totali?: number;
    /**
     * Dispositivi che hanno accettato la consegna a Firebase.
     */
    inviati?: number;
    /**
     * Dispositivi per cui la consegna e\' stata rifiutata.
     */
    falliti?: number;
    /**
     * Token rimossi perche\' Firebase li ha dichiarati non piu\' registrati.
     */
    token_rimossi?: number;
    /**
     * Motivo del fallimento complessivo; assente se l\'invio e\' andato a termine.
     */
    errore?: string;
    created_at?: string;
    completato_at?: string;
    /**
     * Id dell\'operatore che ha lanciato l\'invio; assente per gli invii di sistema.
     */
    actor_user_id?: string;
    /**
     * Email dell\'operatore al momento dell\'invio; presente solo per il SUPERADMIN, mai per un OP_COMUNE (per lui vale mittente_nome).
     */
    actor_snapshot?: string;
    /**
     * Nome e cognome dell\'operatore che ha lanciato l\'invio; assente per gli invii di sistema o se l\'anagrafica dell\'operatore non ha ne\' nome ne\' cognome.
     */
    mittente_nome?: string;
}
export enum NotificaPushInvioDTODestinatarioTipoEnum {
    UTENTE_SINGOLO = 'UTENTE_SINGOLO',
    GLOBALE = 'GLOBALE',
    SELEZIONE = 'SELEZIONE'
};
export enum NotificaPushInvioDTOStatoEnum {
    IN_CORSO = 'IN_CORSO',
    COMPLETATO = 'COMPLETATO',
    FALLITO = 'FALLITO'
};



